// extracted by mini-css-extract-plugin
export default {"modified":"modified-value_modified__yG79A","default":"modified-value_default__6kfUP"};